import { NavLink } from '@components/NavList/NavList';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { KitNamedLink } from '@services/kits/kit';

interface KitItemLinkProps {
  kit: KitNamedLink;
}

export function KitItemLink({ kit }: Readonly<KitItemLinkProps>) {
  const { kitData, name, url } = kit;

  return (
    <NavLink data-testid="kit-node" to={url}>
      <KitItemLinkName key={kitData.configurationPID} data-testid={kitData.name}>
        {name} <Chevron icon={faChevronRight} />
      </KitItemLinkName>
    </NavLink>
  );
}

const KitItemLinkName = styled(MUITypography)`
  display: flex;
  justify-content: space-between;
  padding: 1px;
  align-items: center;
  width: 100%;
`;

const Chevron = styled(FontAwesomeIcon)`
  vertical-align: middle;
`;
